import { Moon, Sun, Home } from 'lucide-react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useStore } from '../../hooks/useStore'
import ProgressBar from './ProgressBar'

export default function Header() {
  const { darkMode, toggleDarkMode, isSyncing, progress } = useStore()
  const navigate = useNavigate()
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-primary-200 dark:bg-primary-950/80 dark:border-primary-800">
      {/* 顶部进度条 */}
      <ProgressBar />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <h1 className="text-xl font-bold text-primary-900 dark:text-white">
              YearCompass
            </h1>
            <span className="hidden sm:inline text-sm text-primary-500">
              2025 → 2026
            </span>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-2">
            {/* Progress & Sync Status */}
            <div className="flex items-center mr-2 space-x-2 sm:space-x-4">
              <div className="flex items-center">
                <span className="text-xs font-medium text-primary-700 dark:text-primary-300">
                  进度 {progress}%
                </span>
              </div>
              <div className="flex items-center">
                <div className={`w-1.5 h-1.5 rounded-full mr-1.5 ${isSyncing ? 'bg-blue-500 animate-pulse' : 'bg-green-500'}`}></div>
                <span className="text-xs text-primary-500">
                  {isSyncing ? '同步中' : '已保存'}
                </span>
              </div>
            </div>

            {!isHome && (
              <button
                onClick={() => navigate('/')}
                className="p-2 rounded-lg hover:bg-primary-100 dark:hover:bg-primary-800 transition-colors"
                aria-label="返回首页"
              >
                <Home className="w-5 h-5" />
              </button>
            )}

            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-lg hover:bg-primary-100 dark:hover:bg-primary-800 transition-colors"
              aria-label="切换主题"
            >
              {darkMode ? (
                <Sun className="w-5 h-5" />
              ) : (
                <Moon className="w-5 h-5" />
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}
